<nz-card class="rounded p-4 mt-3" nzHoverable>
  <nz-skeleton *ngIf="loading" [nzLoading]="loading" [nzActive]="true"></nz-skeleton>
  <div *ngIf="!loading" class="d-flex flex-column">
    <h6>Mobile Key (Android and iOS)</h6>
    <span>
      Secure your API Key for Android and iOS applications. Every request from an Android or iOS device will be verified by RajaOngkir or Collaborator OpenAPI to ensure it comes from the correct application, matching the certificate (for Android) and package name listed below. You can find sample code to obtain the certificate and package name here. Enter one certificate and package name :
    </span>
  </div>
  <div *ngIf="!loading" class="mt-3">
    <nz-table #basicTable [nzData]="listMobileKey" [nzFrontPagination]="false" [nzScroll]="{ x: '1000px' }">
      <thead>
        <tr>
          <th style="width: 50px !important"></th>
          <th style="width: 350px !important">Key Certificate</th>
          <th style="width: 350px !important">Package Name</th>
          <th style="width: 150px !important">Added</th>
          <th style="width: 150px !important">Device</th>
          <th style="width: 100px !important"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let items of listMobileKey; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ items.certificate || "-" }}</td>
          <td>{{ items.package_name || "-" }}</td>
          <td>{{ items.created_at | date : "dd/MM/YYYY" }}</td>
          <td>
            <span [ngClass]="classdeviceType(items.type)" class="rounded">
              {{ deviceType(items.type) }}
            </span>
          </td>
          <td>
            <button class="btn p-0" (click)="deleteReferrer(items.id, items.type)">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/trash.svg"
                alt="delete"
                width="20px"
              />
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <div class="mt-3">
      <button class="btn btn-primary text-white" (click)="addMobileKey()">
        Add Key
      </button>
    </div>
  </div>
</nz-card>
